// Module
var code = "<div class=\"error-message\" ng-if=\"visible\">Your cart will expire soon. Please complete your purchase within {{'minutes' | pluralize : minutesLeft : true}}.</div>\n";
// Exports
module.exports = code;